var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagSwaziland(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16594)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.4124 22.9671C31.4295 20.8636 32 18.5037 32 16.0106C32 13.5175 31.4295 11.1575 30.4124 9.05409L16 8.3584L1.58763 9.05402C0.5705 11.1575 0 13.5175 0 16.0106C0 18.5037 0.5705 20.8636 1.58763 22.9671L16 23.6628L30.4124 22.9671Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0003 0.0107422C9.65689 0.0107422 4.17589 3.7023 1.58789 9.05424H30.4126C27.8246 3.7023 22.3436 0.0107422 16.0003 0.0107422Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0003 32.0108C9.65689 32.0108 4.17589 28.3192 1.58789 22.9673H30.4126C27.8246 28.3192 22.3436 32.0108 16.0003 32.0108Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2444 11.1411H0.755562C0.265437 12.6767 0 14.3126 0 16.0107C0 17.7087 0.265437 19.3447 0.755562 20.8802H31.2444C31.7346 19.3447 32 17.7087 32 16.0107C32 14.3126 31.7346 12.6767 31.2444 11.1411Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.56519 15.3154H26.4347V16.7067H5.56519V15.3154Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.34741 12.5327H23.6518V13.924H8.34741V12.5327Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7515 16.0109C23.7515 16.0109 20.1739 20.1848 16 20.1848C11.8261 20.1848 11.826 16.0109 11.826 16.0109C11.826 16.0109 11.8261 11.8369 16 11.8369C20.1739 11.8369 23.7515 16.0109 23.7515 16.0109Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9996 20.1848C11.8257 20.1848 8.24805 16.0109 8.24805 16.0109C8.24805 16.0109 11.8257 11.8369 15.9996 11.8369",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2178 14.6196H14.6091V17.4023H13.2178V14.6196Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3916 14.6196H18.7829V17.4023H17.3916V14.6196Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5652 17.4023C6.3336 17.4023 6.95651 16.7793 6.95651 16.0109C6.95651 15.2425 6.3336 14.6196 5.5652 14.6196C4.7968 14.6196 4.17389 15.2425 4.17389 16.0109C4.17389 16.7793 4.7968 17.4023 5.5652 17.4023Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4343 17.4023C27.2027 17.4023 27.8257 16.7793 27.8257 16.0109C27.8257 15.2425 27.2027 14.6196 26.4343 14.6196C25.6659 14.6196 25.043 15.2425 25.043 16.0109C25.043 16.7793 25.6659 17.4023 26.4343 17.4023Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16594"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0107422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagSwaziland);
export default __webpack_public_path__ + "static/media/flag_swaziland.1cccee04bbeef7a96ae11bc162bd3e2e.svg";
export { ForwardRef as ReactComponent };